import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import Project from '../../interfaces/Project.interface';

// selector to get the currently selected project from the state
const selectProjects = (state: RootState) => state.projects;

export const selectSelectedProjectId = () => createSelector(
  [selectProjects],
  (projects) => projects.selectedProjectId
);

export const selectBaseProjectId = () => createSelector(
  [selectProjects],
  (projects) => projects.baseProjectId
);

export const selectAllProjects = () => createSelector(
  [selectProjects],
  (projects) => projects.projects
);

export const selectProjectById = (id: number | null) => createSelector(
  [selectProjects],
  (projects) => {
    return projects.projects.find((project: Project) => project.id === id)
  }
);